import Map from './models/map';
import Nonakass from './models/nonakass';
import NagataStation from './models/nagata-station';
import TokuanStation from './models/tokuan-station';

type DataToCreate = {
  map: HTMLDivElement;
  nonakass: HTMLDivElement;
  nagataStation: HTMLDivElement;
  tokuanStation: HTMLDivElement;
}

class GoogleMap {

  readonly map: Map;
  readonly nonakass: Nonakass;
  readonly nagataStation: NagataStation;
  readonly tokuanStation: TokuanStation;

  constructor(data: DataToCreate) {
    this.map = new Map({ div: data.map });
    this.nonakass = new Nonakass({ div: data.nonakass, map: this.map });
    this.nagataStation = new NagataStation({ div: data.nagataStation, map: this.map });
    this.tokuanStation = new TokuanStation({ div: data.tokuanStation, map: this.map });
  }

  async watch(): Promise<GoogleMap> {
    await this.map.watch();
    return this;
  }

}

export default GoogleMap;